import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';

export default ShModel.extend({
  placeId: attr('string'), // May be unpopulated
  formattedAddress: attr('string'),
  lat: attr('number'),
  lng: attr('number'),
  createdAt: attr('date'),
  updatedAt: attr('date'),

  user: belongsTo('user', { async: false }),

  getGoogleMapsLink: computed(
    'placeId',
    function () {
      const placeId = this.get('placeId');
      const formattedAddress = encodeURIComponent(this.get('formattedAddress')).replace(/%20/g, "+");

      if (placeId) {
        return `https://www.google.com/maps/search/?api=1&query=${formattedAddress}&query_place_id=${placeId}`;
      } else {
        return `https://www.google.com/maps/place/?q=place_id:${placeId}`;
      }
    }
  ),
});
